import angular from 'angular';

class ModalDeleteComunityCtrl {
    /*@ngInject*/
    constructor(CommunitySvc, logger) {
        this.CommunitySvc = CommunitySvc;
        this.logger = logger;
    }

    deleteCommunity() {
        let vm = this;
        this.CommunitySvc.deleteComunity(vm.resolve.community.eid).then(
            function (data) {
                vm.logger.success('success.delete', data, null, {
                    entityName: vm.resolve.community.name,
                });
                vm.modalInstance.close();
            },
            function () {
                vm.logger.error('error.delete');
                vm.cancel();
            }
        );
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.principal').component('modalDeleteCommunity', {
    templateUrl: require('./modal-delete-comunity.html'),
    controller: ModalDeleteComunityCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
